import { createContext, useContext } from 'react';
import { useThemeMode } from '../lib/theme';

// Hell/Dunkel-Modus-Provider. Zwei fixe Paletten (Dark/Light); die Wahl wird
// pro Gerät in localStorage gemerkt, Default folgt der Systemeinstellung.
// Die eigentliche Logik liegt in src/lib/theme.js.
const ThemeContext = createContext({ mode: 'dark', toggle: () => {} });

export function ThemeProvider({ children }) {
  const { mode, toggle } = useThemeMode();
  return (
    <ThemeContext.Provider value={{ mode, toggle }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
